// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/word/Slovodel.css */

/* ГЛАВНЫЙ КОНТЕЙНЕР */
.slovodel-board {
  position: fixed;
  /* Изменяем: привязываемся к верху, а не к центру */
  top: 20px;
  left: 50%;
  transform: translateX(-50%); /* Только по горизонтали */

  width: 95%;
  max-width: 400px;
  /* Высота теперь зависит от экрана, но зажата лимитами */
  height: calc(100% - 40px);
  max-height: 800px;
  min-height: 560px;

  background-color: #1a1a2e; /* Более глубокий темный цвет */
  background-image:
    radial-gradient(circle at center, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 1) 100%);
  border: 4px solid #334155;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  display: flex; flex-direction: column;
  color: #f8fafc;
  font-family: 'Courier New', monospace;
  padding: 20px;
  box-sizing: border-box;
  z-index: 6000;
  overflow: hidden; /* Чтобы ничего не вылезало за границы */

  /* Плавность для возможных микро-сдвигов */
  transition: top 0.3s ease-out;
}

/* HEADER */
.sd-header {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Центрирует всё по вертикали */
  padding-bottom: 12px;
  margin-bottom: 15px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.sd-title, .sd-timer, .sd-score {
  margin: 0; /* Убираем дефолтные отступы, которые могут ломать линию */
  line-height: 1; /* Чтобы высота строки не добавляла «воздуха» сверху */
}
.sd-title {
  font-size: 24px; /* Увеличили размер */
  font-weight: 700;
  color: #fbbf24; /* Золотистый акцент на базовом слове */
  letter-spacing: 5px;
  text-transform: uppercase;
  font-family: 'Courier New', monospace;
  max-width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* Добавим небольшое свечение, чтобы слово "горело" */
  text-shadow: 0 0 10px rgba(251, 191, 36, 0.3);
}
.sd-score { font-size: 20px; font-weight: bold; color: #fbbf24; }

/* INPUT AREA - ТЕПЕРЬ СВЕРХУ */
.sd-input-area {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  align-items: stretch; /* Растягивает элементы по высоте самой высокой кнопки */
}

/* Обертка для инпута и крестика */
.sd-input-wrapper {
  position: relative;
  flex: 1 1;
  display: flex;
}

.sd-input {
  width: 100%;
  height: 56px; /* Явно задаем высоту как у кнопки Backspace */
  background: rgba(0, 0, 0, 0.4);
  border: 2px solid #334155;
  color: #fff;
  font-size: 22px;
  font-family: inherit;
  border-radius: 8px;
  text-align: center;
  letter-spacing: 3px;
  box-sizing: border-box;

  /* ВАЖНО: одинаковые отступы по бокам сохраняют центрирование текста */
  padding: 0 0px;

  transition: all 0.2s;
}
.sd-input:focus { outline: none; border-color: #fbbf24; background: rgba(0,0,0,0.6); }
/* Маленький крестик внутри инпута */
.sd-input-clear-x {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.3); /* Тусклый, чтобы не отвлекать */
  cursor: pointer;
  padding: 8px; /* Увеличиваем зону клика */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: color 0.2s;
  z-index: 5;
}

.sd-input-clear-x:hover {
  color: #ef4444; /* Краснеет при наведении/нажатии */
}

.sd-input::placeholder {
  font-size: 17px;
  letter-spacing: 0;
  opacity: 0.5;
  text-transform: none; /* Чтобы "Введите слово" не превращалось в капс принудительно */
}
.sd-input.locked { opacity: 0.7; }

/* Кнопка Backspace (правая) */
.sd-action-btn-square {
  width: 48px;
  height: 56px; /* Высота совпадает с инпутом */
  background: #334155;
  color: #fff;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 0 #1e293b;
  flex-shrink: 0;
}

.sd-action-btn-square:active {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #1e293b;
}

/* BASE WORD TILES */
.sd-base-word-container {
  display: flex; flex-wrap: wrap; justify-content: center; gap: 8px;
  margin-bottom: 20px;
  padding: 10px;
  background: rgba(255,255,255,0.03);
  border-radius: 12px;
}

.sd-letter-tile {
  width: 42px; height: 48px;
  background: #f1f5f9;
  color: #0f172a;
  font-size: 26px; font-weight: 900;
  display: flex; align-items: center; justify-content: center;
  border-radius: 6px;
  box-shadow: 0 5px 0 #cbd5e1;
  cursor: pointer;
  transition: all 0.1s;
  margin: 4px 0px;
}
.sd-letter-tile:active { transform: translateY(3px); box-shadow: 0 2px 0 #cbd5e1; }

/* Состояние: буква использована в текущем наборе */
.sd-letter-tile.used {
  background: #94a3b8; /* Темнее и серее */
  color: rgba(15, 23, 42, 0.4);
  /* Эффект "вдавленности" */
  box-shadow: inset 0 4px 4px rgba(0,0,0,0.3);
  transform: translateY(3px);
  filter: grayscale(0.8);
  /* Мы НЕ отключаем pointer-events, чтобы можно было нажать повторно */
}

/* Анимация тряски всей клавиатуры при ошибке */
.sd-base-word-container.shake-kb {
  animation: sd-shake-kb 0.4s cubic-bezier(.36,.07,.19,.97) both;
}

@keyframes sd-shake-kb {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(4px, 0, 0); }
}

/* Выделение последней введенной буквы (кандидат на удаление) */
.sd-letter-tile.used.last-char {
  box-sizing: border-box;
  border: 1px solid #fbbf24; /* Золотистая рамка */
  filter: grayscale(0.5); /* Чуть ярче остальных использованных */
}

/* Закрепляем основные элементы */
.sd-header,
.sd-input-area,
.sd-base-word-container,
.sd-submit-btn-large {
  flex-shrink: 0;
}

/* --- СТИЛИЗАЦИЯ ПОЛОСЫ ПРОКРУТКИ (ФИКС) --- */

.sd-list-container {
  flex-grow: 1;
  flex-shrink: 0;
  min-height: 120px;
  background: rgba(15, 23, 42, 0.4);
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 12px;
  padding-right: 8px;
  overflow-y: auto;
  margin-top: 10px;

  /* Для Firefox */
  scrollbar-width: thin !important;
  scrollbar-color: #334155 #000000 !important;
}

/* Ширина и принудительный показ */
.sd-list-container::-webkit-scrollbar {
  width: 6px !important;
  display: block !important;
}

/* Фон дорожки */
.sd-list-container::-webkit-scrollbar-track {
  background-color: #000000 !important;
  border-radius: 10px !important;
  margin: 4px 0 !important;
}

/* Ползунок */
.sd-list-container::-webkit-scrollbar-thumb {
  background-color: #334155 !important;
  border-radius: 10px !important;
  border: 1px solid #000000 !important;
}

/* Цвет при наведении */
.sd-list-container::-webkit-scrollbar-thumb:hover {
  background-color: #fbbf24 !important;
}

/* Оптимизация прокрутки на мобильных */
.add-scroll {
  -webkit-overflow-scrolling: touch;
}

/* ШИРОКАЯ КНОПКА ОТПРАВКИ */
.sd-submit-btn-large {
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 18px;
  font-weight: 900;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-bottom: 20px;
  text-transform: uppercase;
  color: #0f172a;
  background: #fbbf24; /* Желтый */
  box-shadow: 0 6px 0 #b45309;
}

.sd-submit-btn-large:disabled { opacity: 1; }
.sd-submit-btn-large:active:not(:disabled) { transform: translateY(3px); box-shadow: 0 3px 0 #b45309; }

/* Цвета состояний кнопки */
.sd-submit-btn-large.status-success {
  background: #22c55e !important;
  color: #fff !important;
  box-shadow: 0 6px 0 #15803d !important;
}
.sd-submit-btn-large.status-error {
  background: #ef4444 !important;
  color: #fff !important;
  box-shadow: 0 6px 0 #b91c1c !important;
}
.sd-submit-btn-large.status-warning {
  background: #3b82f6 !important;
  color: #fff !important;
  box-shadow: 0 6px 0 #1d4ed8 !important;
}

/* ПЕЧАТЬ (STAMP) */
.sd-stamp-overlay {
  position: absolute;
  top: 15%; /* Подняли выше (верхняя треть) */
  left: 0; right: 0;
  height: 100px; /* Ограничили высоту, чтобы не перекрывать нижние кнопки */
  display: flex; align-items: center; justify-content: center;
  pointer-events: none; /* Пропускает клики */
  background: transparent; /* Убрали темный фон оверлея */
  z-index: 100;
}

.sd-stamp {
  padding: 10px 20px;
  font-size: 22px;
  font-weight: 900;
  text-transform: uppercase;
  border: 6px double;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.85); /* Полупрозрачный фон */
  opacity: 0.8; /* Сама печать полупрозрачная */
  box-shadow: 0 4px 15px rgba(0,0,0,0.3);
  transform: rotate(-10deg) scale(2);
  opacity: 0;
  animation: sdStampIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

@keyframes sdStampIn {
  to { transform: rotate(-10deg) scale(1); opacity: 1; }
}

.stamp-ok { color: #15803d; border-color: #15803d; }
.stamp-fail { color: #b91c1c; border-color: #b91c1c; }
.stamp-warning { color: #1d4ed8; border-color: #1d4ed8; }

/* WORD LIST */
.sd-list-container {
  flex: 1 1;
  background: rgba(15, 23, 42, 0.4); /* Сделали темным под стиль игры */
  color: #cbd5e1;
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 6px;
  overflow-y: auto;
}

.sd-list-container * {
  touch-action: pan-y;
}


.sd-empty-hint {
  text-align: center;
  opacity: 0.5;
  padding: 20px 10px; /* Добавили паддинг для центровки */
  font-style: italic;
  font-size: 14px;
  color: #bdc3c7;
  line-height: 1.4;
  /* Если открыто определение, хинт будет просто идти следом */
}

/* GAMEOVER */
.sd-gameover {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  background: #0f172a;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  z-index: 200;
}
.go-title { font-size: 24px; font-weight: 900; color: #fbbf24; margin-bottom: 20px; }
.go-score { font-size: 40px; color: #fff; font-weight: 900; margin-bottom: 5px; }
.go-btn {
  background: #fbbf24; color: #0f172a; border: none; padding: 16px 40px;
  font-size: 18px; font-weight: 900; border-radius: 8px; cursor: pointer;
  box-shadow: 0 4px 0 #b45309;
}

/* Чтобы контент на финише скроллился, если его много */
.sd-gameover.add-scroll {
  overflow-y: auto;
  justify-content: flex-start;
  padding-top: 40px;
  padding-bottom: 20px;
}

/* Зона определения ТЕПЕРЬ ВНУТРИ списка */
.sd-definition-panel {
  background: rgba(251, 191, 36, 0.12);
  border: 1px solid rgba(251, 191, 36, 0.3);
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px; /* Отступ от хинта или списка слов */
  cursor: pointer;
  animation: sdFadeIn 0.3s ease-out;
  flex-shrink: 0;
}

@keyframes sdFadeIn {
  from { opacity: 0; transform: scale(0.98); }
  to { opacity: 1; transform: scale(1); }
}

.sd-def-word {
  display: block;
  font-weight: 900;
  color: #fbbf24;
  text-transform: uppercase;
  font-size: 14px;
  margin-bottom: 6px;
  border-bottom: 1px solid rgba(251, 191, 36, 0.2);
}

.sd-def-text {
  font-size: 13px;
  line-height: 1.4;
  color: #f1f5f9;
  font-family: sans-serif;
  /* До 5 строк текста */
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.sd-def-close-hint {
  display: block;
  font-size: 10px;
  color: #94a3b8;
  margin-top: 8px;
  text-align: right;
  font-style: italic;
  opacity: 0.7;
}

/* Тег слова в списке */
.sd-word-tag {
  font-weight: 700;
  font-size: 14px;
  color: #f8fafc;
  letter-spacing: 0.5px;
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  padding: 4px 6px;
  border-radius: 4px;
  margin: 3px 0px 0px 3px;
  cursor: pointer;
  transition: background 0.2s;
}

.sd-word-tag:hover {
  background: rgba(255, 255, 255, 0.1);
}

.sd-word-tag.has-def {
  border-bottom: 1px solid rgba(251, 191, 36, 0.5);
}

.sd-word-help-icon {
  font-size: 10px;
  color: #fbbf24;
  margin-left: 4px;
  opacity: 0.8;
}

.sd-words-cloud {
  padding-right: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/slovodel/Slovodel.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B,sBAAsB;AACtB;EACE,eAAe;EACf,mDAAmD;EACnD,SAAS;EACT,SAAS;EACT,2BAA2B,EAAE,0BAA0B;;EAEvD,UAAU;EACV,gBAAgB;EAChB,wDAAwD;EACxD,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;;EAEjB,yBAAyB,EAAE,+BAA+B;EAC1D;yFACuF;EACvF,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;EAChD,aAAa,EAAE,sBAAsB;EACrC,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB,EAAE,wCAAwC;;EAE1D,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAE,gCAAgC;EACrD,oBAAoB;EACpB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,SAAS,EAAE,0DAA0D;EACrE,cAAc,EAAE,sDAAsD;AACxE;AACA;EACE,eAAe,EAAE,qBAAqB;EACtC,gBAAgB;EAChB,cAAc,EAAE,uCAAuC;EACvD,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qDAAqD;EACrD,6CAA6C;AAC/C;AACA,YAAY,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAEhE,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB,EAAE,wDAAwD;AAChF;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,8CAA8C;EAC5D,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;;EAEtB,sEAAsE;EACtE,cAAc;;EAEd,oBAAoB;AACtB;AACA,kBAAkB,aAAa,EAAE,qBAAqB,EAAE,2BAA2B,EAAE;AACrF,oCAAoC;AACpC;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,+BAA+B,EAAE,gCAAgC;EACjE,eAAe;EACf,YAAY,EAAE,2BAA2B;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,oBAAoB,EAAE,+DAA+D;AACvF;AACA,mBAAmB,YAAY,EAAE;;AAEjC,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY,EAAE,+BAA+B;EAC7C,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa,EAAE,eAAe,EAAE,uBAAuB,EAAE,QAAQ;EACjE,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe,EAAE,gBAAgB;EACjC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA,yBAAyB,0BAA0B,EAAE,2BAA2B,EAAE;;AAElF,mDAAmD;AACnD;EACE,mBAAmB,EAAE,mBAAmB;EACxC,4BAA4B;EAC5B,0BAA0B;EAC1B,2CAA2C;EAC3C,0BAA0B;EAC1B,sBAAsB;EACtB,qEAAqE;AACvE;;AAEA,+CAA+C;AAC/C;EACE,8DAA8D;AAChE;;AAEA;EACE,WAAW,kCAAkC,EAAE;EAC/C,WAAW,iCAAiC,EAAE;EAC9C,gBAAgB,kCAAkC,EAAE;EACpD,WAAW,iCAAiC,EAAE;AAChD;;AAEA,+DAA+D;AAC/D;EACE,sBAAsB;EACtB,yBAAyB,EAAE,qBAAqB;EAChD,sBAAsB,EAAE,uCAAuC;AACjE;;AAEA,iCAAiC;AACjC;;;;EAIE,cAAc;AAChB;;AAEA,+CAA+C;;AAE/C;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;;EAEhB,gBAAgB;EAChB,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA,aAAa;AACb;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;AACtC;;AAEA,uCAAuC;AACvC;EACE,iCAAiC;AACnC;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iDAAiD;EACjD,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB,EAAE,WAAW;EAChC,2BAA2B;AAC7B;;AAEA,gCAAgC,UAAU,EAAE;AAC5C,6CAA6C,0BAA0B,EAAE,2BAA2B,EAAE;;AAEtG,2BAA2B;AAC3B;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,QAAQ,EAAE,iCAAiC;EAC3C,OAAO,EAAE,QAAQ;EACjB,aAAa,EAAE,0DAA0D;EACzE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,oBAAoB,EAAE,qBAAqB;EAC3C,uBAAuB,EAAE,8BAA8B;EACvD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC,EAAE,uBAAuB;EAC9D,YAAY,EAAE,+BAA+B;EAC7C,sCAAsC;EACtC,kCAAkC;EAClC,UAAU;EACV,0EAA0E;AAC5E;;AAEA;EACE,KAAK,kCAAkC,EAAE,UAAU,EAAE;AACvD;;AAEA,YAAY,cAAc,EAAE,qBAAqB,EAAE;AACnD,cAAc,cAAc,EAAE,qBAAqB,EAAE;AACrD,iBAAiB,cAAc,EAAE,qBAAqB,EAAE;;AAExD,cAAc;AACd;EACE,SAAO;EACP,iCAAiC,EAAE,kCAAkC;EACrE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB,EAAE,mCAAmC;EACvD,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA,aAAa;AACb;EACE,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACxD,mBAAmB;EACnB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB;EACnF,YAAY;AACd;AACA,YAAY,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACpF,YAAY,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAChF;EACE,mBAAmB,EAAE,cAAc,EAAE,YAAY,EAAE,kBAAkB;EACrE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe;EACtE,2BAA2B;AAC7B;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,eAAe;EACf,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,QAAQ;AACV","sourcesContent":["/* games/word/Slovodel.css */\n\n/* ГЛАВНЫЙ КОНТЕЙНЕР */\n.slovodel-board {\n  position: fixed;\n  /* Изменяем: привязываемся к верху, а не к центру */\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%); /* Только по горизонтали */\n\n  width: 95%;\n  max-width: 400px;\n  /* Высота теперь зависит от экрана, но зажата лимитами */\n  height: calc(100% - 40px);\n  max-height: 800px;\n  min-height: 560px;\n\n  background-color: #1a1a2e; /* Более глубокий темный цвет */\n  background-image:\n    radial-gradient(circle at center, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 1) 100%);\n  border: 4px solid #334155;\n  border-radius: 12px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n  display: flex; flex-direction: column;\n  color: #f8fafc;\n  font-family: 'Courier New', monospace;\n  padding: 20px;\n  box-sizing: border-box;\n  z-index: 6000;\n  overflow: hidden; /* Чтобы ничего не вылезало за границы */\n\n  /* Плавность для возможных микро-сдвигов */\n  transition: top 0.3s ease-out;\n}\n\n/* HEADER */\n.sd-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; /* Центрирует всё по вертикали */\n  padding-bottom: 12px;\n  margin-bottom: 15px;\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n}\n\n.sd-title, .sd-timer, .sd-score {\n  margin: 0; /* Убираем дефолтные отступы, которые могут ломать линию */\n  line-height: 1; /* Чтобы высота строки не добавляла «воздуха» сверху */\n}\n.sd-title {\n  font-size: 24px; /* Увеличили размер */\n  font-weight: 700;\n  color: #fbbf24; /* Золотистый акцент на базовом слове */\n  letter-spacing: 5px;\n  text-transform: uppercase;\n  font-family: 'Courier New', monospace;\n  max-width: 70%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* Добавим небольшое свечение, чтобы слово \"горело\" */\n  text-shadow: 0 0 10px rgba(251, 191, 36, 0.3);\n}\n.sd-score { font-size: 20px; font-weight: bold; color: #fbbf24; }\n\n/* INPUT AREA - ТЕПЕРЬ СВЕРХУ */\n.sd-input-area {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n  align-items: stretch; /* Растягивает элементы по высоте самой высокой кнопки */\n}\n\n/* Обертка для инпута и крестика */\n.sd-input-wrapper {\n  position: relative;\n  flex: 1;\n  display: flex;\n}\n\n.sd-input {\n  width: 100%;\n  height: 56px; /* Явно задаем высоту как у кнопки Backspace */\n  background: rgba(0, 0, 0, 0.4);\n  border: 2px solid #334155;\n  color: #fff;\n  font-size: 22px;\n  font-family: inherit;\n  border-radius: 8px;\n  text-align: center;\n  letter-spacing: 3px;\n  box-sizing: border-box;\n\n  /* ВАЖНО: одинаковые отступы по бокам сохраняют центрирование текста */\n  padding: 0 0px;\n\n  transition: all 0.2s;\n}\n.sd-input:focus { outline: none; border-color: #fbbf24; background: rgba(0,0,0,0.6); }\n/* Маленький крестик внутри инпута */\n.sd-input-clear-x {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: rgba(255, 255, 255, 0.3); /* Тусклый, чтобы не отвлекать */\n  cursor: pointer;\n  padding: 8px; /* Увеличиваем зону клика */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  transition: color 0.2s;\n  z-index: 5;\n}\n\n.sd-input-clear-x:hover {\n  color: #ef4444; /* Краснеет при наведении/нажатии */\n}\n\n.sd-input::placeholder {\n  font-size: 17px;\n  letter-spacing: 0;\n  opacity: 0.5;\n  text-transform: none; /* Чтобы \"Введите слово\" не превращалось в капс принудительно */\n}\n.sd-input.locked { opacity: 0.7; }\n\n/* Кнопка Backspace (правая) */\n.sd-action-btn-square {\n  width: 48px;\n  height: 56px; /* Высота совпадает с инпутом */\n  background: #334155;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  cursor: pointer;\n  box-shadow: 0 4px 0 #1e293b;\n  flex-shrink: 0;\n}\n\n.sd-action-btn-square:active {\n  transform: translateY(2px);\n  box-shadow: 0 2px 0 #1e293b;\n}\n\n/* BASE WORD TILES */\n.sd-base-word-container {\n  display: flex; flex-wrap: wrap; justify-content: center; gap: 8px;\n  margin-bottom: 20px;\n  padding: 10px;\n  background: rgba(255,255,255,0.03);\n  border-radius: 12px;\n}\n\n.sd-letter-tile {\n  width: 42px; height: 48px;\n  background: #f1f5f9;\n  color: #0f172a;\n  font-size: 26px; font-weight: 900;\n  display: flex; align-items: center; justify-content: center;\n  border-radius: 6px;\n  box-shadow: 0 5px 0 #cbd5e1;\n  cursor: pointer;\n  transition: all 0.1s;\n  margin: 4px 0px;\n}\n.sd-letter-tile:active { transform: translateY(3px); box-shadow: 0 2px 0 #cbd5e1; }\n\n/* Состояние: буква использована в текущем наборе */\n.sd-letter-tile.used {\n  background: #94a3b8; /* Темнее и серее */\n  color: rgba(15, 23, 42, 0.4);\n  /* Эффект \"вдавленности\" */\n  box-shadow: inset 0 4px 4px rgba(0,0,0,0.3);\n  transform: translateY(3px);\n  filter: grayscale(0.8);\n  /* Мы НЕ отключаем pointer-events, чтобы можно было нажать повторно */\n}\n\n/* Анимация тряски всей клавиатуры при ошибке */\n.sd-base-word-container.shake-kb {\n  animation: sd-shake-kb 0.4s cubic-bezier(.36,.07,.19,.97) both;\n}\n\n@keyframes sd-shake-kb {\n  10%, 90% { transform: translate3d(-1px, 0, 0); }\n  20%, 80% { transform: translate3d(2px, 0, 0); }\n  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }\n  40%, 60% { transform: translate3d(4px, 0, 0); }\n}\n\n/* Выделение последней введенной буквы (кандидат на удаление) */\n.sd-letter-tile.used.last-char {\n  box-sizing: border-box;\n  border: 1px solid #fbbf24; /* Золотистая рамка */\n  filter: grayscale(0.5); /* Чуть ярче остальных использованных */\n}\n\n/* Закрепляем основные элементы */\n.sd-header,\n.sd-input-area,\n.sd-base-word-container,\n.sd-submit-btn-large {\n  flex-shrink: 0;\n}\n\n/* --- СТИЛИЗАЦИЯ ПОЛОСЫ ПРОКРУТКИ (ФИКС) --- */\n\n.sd-list-container {\n  flex-grow: 1;\n  flex-shrink: 0;\n  min-height: 120px;\n  background: rgba(15, 23, 42, 0.4);\n  border: 1px solid #334155;\n  border-radius: 8px;\n  padding: 12px;\n  padding-right: 8px;\n  overflow-y: auto;\n  margin-top: 10px;\n\n  /* Для Firefox */\n  scrollbar-width: thin !important;\n  scrollbar-color: #334155 #000000 !important;\n}\n\n/* Ширина и принудительный показ */\n.sd-list-container::-webkit-scrollbar {\n  width: 6px !important;\n  display: block !important;\n}\n\n/* Фон дорожки */\n.sd-list-container::-webkit-scrollbar-track {\n  background-color: #000000 !important;\n  border-radius: 10px !important;\n  margin: 4px 0 !important;\n}\n\n/* Ползунок */\n.sd-list-container::-webkit-scrollbar-thumb {\n  background-color: #334155 !important;\n  border-radius: 10px !important;\n  border: 1px solid #000000 !important;\n}\n\n/* Цвет при наведении */\n.sd-list-container::-webkit-scrollbar-thumb:hover {\n  background-color: #fbbf24 !important;\n}\n\n/* Оптимизация прокрутки на мобильных */\n.add-scroll {\n  -webkit-overflow-scrolling: touch;\n}\n\n/* ШИРОКАЯ КНОПКА ОТПРАВКИ */\n.sd-submit-btn-large {\n  width: 100%;\n  padding: 16px;\n  border: none;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 18px;\n  font-weight: 900;\n  cursor: pointer;\n  display: flex; align-items: center; justify-content: center;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  margin-bottom: 20px;\n  text-transform: uppercase;\n  color: #0f172a;\n  background: #fbbf24; /* Желтый */\n  box-shadow: 0 6px 0 #b45309;\n}\n\n.sd-submit-btn-large:disabled { opacity: 1; }\n.sd-submit-btn-large:active:not(:disabled) { transform: translateY(3px); box-shadow: 0 3px 0 #b45309; }\n\n/* Цвета состояний кнопки */\n.sd-submit-btn-large.status-success {\n  background: #22c55e !important;\n  color: #fff !important;\n  box-shadow: 0 6px 0 #15803d !important;\n}\n.sd-submit-btn-large.status-error {\n  background: #ef4444 !important;\n  color: #fff !important;\n  box-shadow: 0 6px 0 #b91c1c !important;\n}\n.sd-submit-btn-large.status-warning {\n  background: #3b82f6 !important;\n  color: #fff !important;\n  box-shadow: 0 6px 0 #1d4ed8 !important;\n}\n\n/* ПЕЧАТЬ (STAMP) */\n.sd-stamp-overlay {\n  position: absolute;\n  top: 15%; /* Подняли выше (верхняя треть) */\n  left: 0; right: 0;\n  height: 100px; /* Ограничили высоту, чтобы не перекрывать нижние кнопки */\n  display: flex; align-items: center; justify-content: center;\n  pointer-events: none; /* Пропускает клики */\n  background: transparent; /* Убрали темный фон оверлея */\n  z-index: 100;\n}\n\n.sd-stamp {\n  padding: 10px 20px;\n  font-size: 22px;\n  font-weight: 900;\n  text-transform: uppercase;\n  border: 6px double;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.85); /* Полупрозрачный фон */\n  opacity: 0.8; /* Сама печать полупрозрачная */\n  box-shadow: 0 4px 15px rgba(0,0,0,0.3);\n  transform: rotate(-10deg) scale(2);\n  opacity: 0;\n  animation: sdStampIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n}\n\n@keyframes sdStampIn {\n  to { transform: rotate(-10deg) scale(1); opacity: 1; }\n}\n\n.stamp-ok { color: #15803d; border-color: #15803d; }\n.stamp-fail { color: #b91c1c; border-color: #b91c1c; }\n.stamp-warning { color: #1d4ed8; border-color: #1d4ed8; }\n\n/* WORD LIST */\n.sd-list-container {\n  flex: 1;\n  background: rgba(15, 23, 42, 0.4); /* Сделали темным под стиль игры */\n  color: #cbd5e1;\n  border: 1px solid #334155;\n  border-radius: 8px;\n  padding: 6px;\n  overflow-y: auto;\n}\n\n.sd-list-container * {\n  touch-action: pan-y;\n}\n\n\n.sd-empty-hint {\n  text-align: center;\n  opacity: 0.5;\n  padding: 20px 10px; /* Добавили паддинг для центровки */\n  font-style: italic;\n  font-size: 14px;\n  color: #bdc3c7;\n  line-height: 1.4;\n  /* Если открыто определение, хинт будет просто идти следом */\n}\n\n/* GAMEOVER */\n.sd-gameover {\n  position: absolute; top: 0; left: 0; right: 0; bottom: 0;\n  background: #0f172a;\n  display: flex; flex-direction: column; align-items: center; justify-content: center;\n  z-index: 200;\n}\n.go-title { font-size: 24px; font-weight: 900; color: #fbbf24; margin-bottom: 20px; }\n.go-score { font-size: 40px; color: #fff; font-weight: 900; margin-bottom: 5px; }\n.go-btn {\n  background: #fbbf24; color: #0f172a; border: none; padding: 16px 40px;\n  font-size: 18px; font-weight: 900; border-radius: 8px; cursor: pointer;\n  box-shadow: 0 4px 0 #b45309;\n}\n\n/* Чтобы контент на финише скроллился, если его много */\n.sd-gameover.add-scroll {\n  overflow-y: auto;\n  justify-content: flex-start;\n  padding-top: 40px;\n  padding-bottom: 20px;\n}\n\n/* Зона определения ТЕПЕРЬ ВНУТРИ списка */\n.sd-definition-panel {\n  background: rgba(251, 191, 36, 0.12);\n  border: 1px solid rgba(251, 191, 36, 0.3);\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 10px; /* Отступ от хинта или списка слов */\n  cursor: pointer;\n  animation: sdFadeIn 0.3s ease-out;\n  flex-shrink: 0;\n}\n\n@keyframes sdFadeIn {\n  from { opacity: 0; transform: scale(0.98); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.sd-def-word {\n  display: block;\n  font-weight: 900;\n  color: #fbbf24;\n  text-transform: uppercase;\n  font-size: 14px;\n  margin-bottom: 6px;\n  border-bottom: 1px solid rgba(251, 191, 36, 0.2);\n}\n\n.sd-def-text {\n  font-size: 13px;\n  line-height: 1.4;\n  color: #f1f5f9;\n  font-family: sans-serif;\n  /* До 5 строк текста */\n  display: -webkit-box;\n  -webkit-line-clamp: 5;\n  line-clamp: 5;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.sd-def-close-hint {\n  display: block;\n  font-size: 10px;\n  color: #94a3b8;\n  margin-top: 8px;\n  text-align: right;\n  font-style: italic;\n  opacity: 0.7;\n}\n\n/* Тег слова в списке */\n.sd-word-tag {\n  font-weight: 700;\n  font-size: 14px;\n  color: #f8fafc;\n  letter-spacing: 0.5px;\n  display: inline-flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 4px 6px;\n  border-radius: 4px;\n  margin: 3px 0px 0px 3px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.sd-word-tag:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.sd-word-tag.has-def {\n  border-bottom: 1px solid rgba(251, 191, 36, 0.5);\n}\n\n.sd-word-help-icon {\n  font-size: 10px;\n  color: #fbbf24;\n  margin-left: 4px;\n  opacity: 0.8;\n}\n\n.sd-words-cloud {\n  padding-right: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
